<template>
  <el-dialog
    title="新增"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :visible.sync="dialogFormVisible"
    width="50%"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      label-position="right"
      :model="form"
      :label-width="formLabelWidth"
      id="form"
    >
      <el-form-item label="商户分类" prop="pid">
        <el-col :span="18">
          <el-select v-model="form.pid" placeholder="请选择商户分类">
            <el-option
              v-for="item in allMerchant"
              :key="item.id"
              :label="item.merchantName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="商户名称" prop="merchantName">
        <el-col :span="18">
          <el-input clearable v-model.trim="form.merchantName"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="联系人" prop="contacts">
        <el-col :span="18">
          <el-input clearable v-model.trim="form.contacts"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="联系电话" prop="telephone">
        <el-col :span="18">
          <el-input clearable v-model.trim="form.telephone"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="图片" prop="picture">
        <el-col :span="18">
          <el-upload
            ref="upload"
            class="avatar-uploader"
            action="/api/tool/oss/upload"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :on-change="beforeAvatarUpload"
            :auto-upload="false"
          >
            <img v-if="imgUrl" :src="imgUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
      </el-form-item>
      <el-form-item class="crop">
        <el-col :span="20">
          <div
            style="
              box-sizing: border-box;
              padding: 20px;
              width: 100%;
              height: 80%;
              border: 1px dashed #ccc;
              border-radius: 10px;
              text-align: center;
              line-height: 50px;
            "
          >
            <template>
              <vue-cropper
                ref="cropper"
                :aspect-ratio="1 / 1"
                :src="imgUrl"
                preview=".preview"
                :view-mode="2"
                :drag-mode="'move'"
                :auto-crop-area="1"
                :crop-box-movable="true"
                :crop-box-resizable="false"
              />
              <div v-if="!imgUrl">裁剪区</div>
              <el-button type="primary" v-if="imgUrl" @click="cropImage">
                裁剪
              </el-button>
            </template>
          </div>
        </el-col>
      </el-form-item>
      <el-form-item label="跳转url" prop="url">
        <el-col :span="18">
          <el-input clearable v-model.trim="form.url"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-col :span="18">
          <el-input
            type="textarea"
            clearable
            v-model.trim="form.remark"
          ></el-input>
        </el-col>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog('normal')">取 消</el-button>
      <el-button type="primary" @click="addrOrEditTrue()">确 定</el-button>
    </div>
  </el-dialog>
</template>
  <script>
import { merchantClassCud, merchantClassAll } from "@/api/url";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  name: "promotional-discounts-add",
  data() {
    return {
      dialogFormVisible: true,
      form: {
        merchantName: "",
        contacts: "",
        telephone: "",
        picture: "",
        url: "",
        remark: "",
        pid: "",
      },
      formLabelWidth: "120px",
      imgUrl: "",
      allMerchant: [],
      croppedImage: null,
      cropperOptions: {
        aspectRatio: 1 / 1,
      },
      loading: false,
      uploadError: null,
    };
  },
  components: {
    VueCropper,
  },
  created() {
    this.getAllMerchantClass();
  },
  methods: {
    getAllMerchantClass() {
      this.$get(`${merchantClassAll()}`).then((res) => {
        this.allMerchant = res ?? [];
      });
    },
    closeDialog(type) {
      this.$emit("closeDialog", type);
    },
    async addrOrEditTrue() {
      try {
        this.loading = true;
        if (this.imgUrl) {
          await this.uploadImage();
        }
        
        const response = await this.$postRequest(`${merchantClassCud()}`, {
          ...this.form,
        });
        
        if (response.status === 200) {
          this.$message.success("新增成功");
          this.closeDialog("add");
        } else {
          this.$message.error("新增失败");
        }
      } catch (error) {
        console.error("Operation error:", error);
      } finally {
        this.loading = false;
      }
    },
    handleAvatarSuccess(res, file) {
      this.form.picture = res?.data ?? "";
      this.imgUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(f) {
      const file = f.raw;
      if (!file) return false;

      // 验证文件类型
      if (!file.type.startsWith("image/")) {
        this.$message.error("请选择图片文件");
        return false;
      }

      // 验证文件大小（2MB）
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("图片大小不能超过 2MB");
        return false;
      }

      // 读取文件
      this.readFile(file);
      return false; // 阻止自动上传
    },
    readFile(file) {
      if (typeof FileReader !== "function") {
        this.$message.error("您的浏览器不支持 FileReader");
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        this.imgUrl = event.target.result;
        this.$nextTick(() => {
          if (this.$refs.cropper) {
            this.$refs.cropper.replace(event.target.result);
          }
        });
      };
      reader.onerror = () => {
        this.$message.error("文件读取失败");
      };
      reader.readAsDataURL(file);
    },
    uploadImage() {
      return new Promise((resolve, reject) => {
        if (!this.$refs.cropper) {
          reject(new Error("裁剪组件未初始化"));
          return;
        }

        this.$refs.cropper.getCroppedCanvas().toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error("图片裁剪失败"));
              return;
            }

            const file = new File([blob], "cropped-image.jpg", {
              type: "image/jpeg",
            });

            const formData = new FormData();
            formData.append("file", file);

            fetch("/api/tool/oss/upload", {
              method: "POST",
              body: formData,
            })
              .then((response) => {
                console.log('response',response);
                if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
              })
              .then((data) => {
                if (data?.data) {
                  this.form.picture = data.data;
                  this.$message.success("图片上传成功");
                  resolve(data);
                } else {
                  throw new Error("上传响应数据格式错误");
                }
              })
              .catch((err) => {
                this.$message.error("图片上传失败");
                console.error("Upload error:", err);
                reject(err);
              });
          },
          "image/jpeg",
          0.9
        );
      });
    },
    cropImage() {
      try {
        if (!this.$refs.cropper) {
          throw new Error("裁剪组件未初始化");
        }
        this.imgUrl = this.$refs.cropper.getCroppedCanvas().toDataURL();
      } catch (error) {
        this.$message.error("图片裁剪失败");
        console.error("Crop error:", error);
      }
    },
  },
};
</script>
  <style scoped>
.el-select {
  width: 100%;
}
.preview {
  width: 100%;
  height: calc(372px * (1/ 1));
  overflow: hidden;
}
.avatar {
  width: 100%;
  height: auto;
}
</style>
<style>
.el-form-item.crop .el-form-item__content {
  margin-left: 0 !important;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
</style>
